import { render, staticRenderFns } from "./PersonBook.vue?vue&type=template&id=480806ca&scoped=true&"
import script from "./PersonBook.vue?vue&type=script&lang=js&"
export * from "./PersonBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480806ca",
  null
  
)

export default component.exports